<div class="participants-view">
  <div *ngIf="showTitleInfo">
    <h2>{{'raci.valuationEffectiveDatesSetup.title' | translate | uppercase}}</h2>
  </div>
  <div class="content-header">
    <svg-icon src='./assets/icons/Project_icon.svg'
              title="{{'raci.participantsAssignment.participants' | translate | uppercase}}"
              class="menu-action-icon svg-icon-red"
              align='center'>
    </svg-icon>
    <h4 *ngIf="!showExternalGrid" class="participants-list-title">
      {{'raci.participantsAssignment.effectiveDatesTitle' | translate | uppercase}}
    </h4>
  </div>
  <div class="participants-list-body">
    <div>
      <div class="participants-description-bold">
        <p>{{'raci.participantsForm.note' | translate }}</p>
      </div>
      <div class="participants-description-container">
        <p>{{'raci.participantsForm.description1' | translate}}</p>
      </div>
      <div class="participants-description-container">
        <p>{{'raci.participantsForm.description2' | translate}}</p>
      </div>
    </div>
    <div class="valuation-event-container">
      <div>
        <div>
          <div class="header-container">
            <div class="header-container">
              <input type="checkbox"
                     style="margin-right: 20px;"
                     [(ngModel)]="isAllSelected"
                     [ngClass]="isFunctionsDisabled ? 'disabled' : ''"
                     (click)="selectAllPropertiesOfValuationEvent()"/>
              <p>Select all properties</p>
            </div>

            <div class="header-container">
              <div class="effective-date">
                {{'raci.participantsForm.startDateTitle' | translate}}
                <kendo-datepicker id="start" class="date-input" [ngClass]="isFunctionsDisabled ? 'disabled' : ''" [(ngModel)]="effectiveStartDate" (change)="changeStartDate($event)"></kendo-datepicker>
              </div>
              <div class="effective-date">
                {{'raci.participantsForm.endDateTitle' | translate}}
                <kendo-datepicker class="date-input" [ngClass]="isFunctionsDisabled ? 'disabled' : ''"  [(ngModel)]="effectiveEndDate"  (change)="changeEndDate($event)"></kendo-datepicker>
              </div>
            </div>
          </div>
          <kendo-grid [data]="valuationEvent?.properties"
                      #propertiesGrid
                      class="kendo-white-grid approval-grid"
                      [selectable]="selectableSettings">
            <kendo-grid-column title="" [width]="50">
              <ng-template kendoGridCellTemplate let-dataItem>
                <div>
                  <input type="checkbox"
                         [ngClass]="isFunctionsDisabled ? 'disabled' : ''"
                         [(ngModel)]="dataItem.isSelected"
                         (click)="onPropertySelect(dataItem)" />
                </div>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column [headerClass]="'participants-grid'"
                               field="municipally"
                               title="{{'raci.portfolioProperties.titleMunicipally' | translate}}"
                               [width]="'auto'"></kendo-grid-column>
            <kendo-grid-column [headerClass]="'participants-grid'"
                               field="address"
                               title="{{'raci.portfolioProperties.titleAddress' | translate}}"
                               [width]="'auto'"></kendo-grid-column>
            <kendo-grid-column [headerClass]="'participants-grid fixed-properties-column-width'"
                               field="propertyName"
                               title="{{'raci.participantsForm.propertyNameTitle' | translate}}"
                               [width]="170">
            </kendo-grid-column>
            <kendo-grid-column [headerClass]="'participants-grid fixed-properties-column-width'"
                               field="valuationEventEffectiveStartDate"
                               title="{{'raci.participantsForm.startDateTitle' | translate}}"
                               [width]="230">
              <ng-template kendoGridCellTemplate let-dataItem>
                <kendo-datepicker id="start" class="date-input" [ngClass]="isFunctionsDisabled ? 'disabled' : ''" [(ngModel)]="dataItem.valuationEventEffectiveStartDate"></kendo-datepicker>
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column [headerClass]="'participants-grid fixed-properties-column-width'"
                               field="valuationEventEffectiveEndDate"
                               title="{{'raci.participantsForm.endDateTitle' | translate}}"
                               [width]="230">
              <ng-template kendoGridCellTemplate let-dataItem>
                <kendo-datepicker class="date-input" [ngClass]="isFunctionsDisabled ? 'disabled' : ''" [(ngModel)]="dataItem.valuationEventEffectiveEndDate"></kendo-datepicker>
</ng-template>
            </kendo-grid-column>
          </kendo-grid>
        </div>
      </div>
    </div>
  </div>
</div>
